// extracted by mini-css-extract-plugin
export default {"input":"poup_input__vMgoH","pb12":"poup_pb12__Impod","pt4":"poup_pt4__hcaF2","pt12":"poup_pt12__TGLry"};